import { useEffect, useState } from "react";
import { navSections, edition } from "@/mocks/gossip";

export default function Masthead() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-sm">
      {/* top meta strip */}
      <div className="hidden md:block border-b border-foreground-950/10 bg-background-100">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-1.5 md:px-6 text-xs text-foreground-600">
          <div className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500 live-dot" />
            <span className="font-label font-medium text-foreground-900">风向滚动</span>
            <span className="truncate">新涉事者档案新增 1 位 · 沈屿尽调口径今日更新</span>
          </div>
          <div className="flex items-center gap-4">
            <span>{edition.date} · {edition.weekday}</span>
            <span className="inline-flex items-center gap-1 text-foreground-600 hover:text-primary-700 cursor-pointer">
              <i className="ri-sun-line text-sm" /> 阅读模式
            </span>
          </div>
        </div>
      </div>

      {/* brand row */}
      <div className="hairline border-b border-foreground-950/10">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6 md:py-4">
          <a href="#lead" className="flex items-center gap-3" aria-label="最近黑料 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
              <i className="ri-ink-bottle-fill text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl md:text-2xl font-black tracking-tight text-foreground-950">最近黑料</span>
              <span className="mt-1 hidden text-[10px] uppercase tracking-[0.22em] text-primary-700 sm:block">近期人物 · 新涉事者 · 聚焦</span>
            </span>
          </a>

          <div className="flex items-center gap-2 md:gap-3">
            <a
              href="#lead"
              className="hidden items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/15 px-3 py-2 text-sm text-foreground-700 hover:border-primary-500 hover:text-primary-700 md:inline-flex"
            >
              <i className="ri-search-line text-sm" />
              搜索人物 / 事件
            </a>
            <a
              href="#download"
              className="hidden whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-700 sm:inline-flex"
            >
              订阅电子周刊
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-foreground-950/15 text-foreground-800 hover:border-primary-500 md:hidden"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {/* nav row */}
      <nav className={`hidden border-b border-foreground-950/10 bg-background-50 md:block ${scrolled ? "shadow-none" : ""}`}>
        <div className="mx-auto flex max-w-7xl items-center gap-1 px-4 md:px-6">
          <span className="mr-3 inline-flex items-center gap-1.5 whitespace-nowrap font-label text-[11px] font-semibold uppercase tracking-wider text-primary-700">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500" /> LIVE
          </span>
          {navSections.map((s, i) => (
            <a
              key={s.key}
              href={`#${s.id}`}
              className="whitespace-nowrap px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-700"
            >
              {s.label}
            </a>
          ))}
          <span className="ml-auto hidden items-center gap-1.5 whitespace-nowrap text-xs text-foreground-500 lg:inline-flex">
            <i className="ri-time-line" /> 每 15 分钟刷新
            <i className="ri-arrow-right-s-line" />
          </span>
        </div>
      </nav>

      {/* mobile menu */}
      {open && (
        <div className="md:hidden border-b border-foreground-950/10 bg-background-100 px-4 py-3">
          <div className="mb-3 flex items-center gap-2 rounded-md border border-foreground-950/15 bg-background-50 px-3 py-2 text-sm text-foreground-600">
            <i className="ri-search-line text-sm" /> 搜索人物 / 事件
          </div>
          {navSections.map((s) => (
            <a
              key={s.key}
              href={`#${s.id}`}
              onClick={() => setOpen(false)}
              className="block whitespace-nowrap px-2 py-2.5 text-sm font-medium text-foreground-800 hover:text-primary-700"
            >
              {s.label}
            </a>
          ))}
          <a
            href="#download"
            onClick={() => setOpen(false)}
            className="mt-2 block whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-center text-sm font-medium text-background-50"
          >
            订阅电子周刊
          </a>
        </div>
      )}
    </header>
  );
}